const sireVettingType = [
    { label: 'SIRE', value: 'sire' },
    { label: 'Vetting', value: 'vetting' },
];

export default sireVettingType;
